export default [
  {
    fieldName: 'Email',
    isRequired: true,
    label: 'E-mail',
    type: 'email',
  },
];



// WEBPACK FOOTER //
// ./src/formFields/forgottenPw.tsx